const mutation = {
  BOOTSTRAP_DATA(state, data) {
    state.data = data;
  },
  MDM_BOOTSTRAP_DATA(state, data) {
    state.mdmBoostrap = data;
  },

  BOOTSTRAP_LOADING(state, status) {
    state.isLoading = status;
  },

  LOGGED_IN(state, status) {
    state.loggedIn = status;
  },
  
  FCM_TOKEN(state, token) {
    state.fcmToken = token;
  },

  SHOW_TERMS_DIALOG(state, status) {
    state.showTermsDialog = status;
  },
  SET_SSO(state, data) {
    state.ssoCheck = (data && data.data) || {};
  },
  ENVIRONMENT_DATA(state, data) {
    state.environmentVariables = data;
  },
  UPDATE_LOGO(state, data) {
    state.logo = data;
  },
  SET_IS_PAYMENT_ERROR(state, data) {
    state.isPaymentError = data;
  }
};

export default mutation;
